import { HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

export const filterResponseBody = <T>(observable: Observable<HttpEvent<void | T>>): Observable<T> =>
  observable.pipe(
    filter(event => event instanceof HttpResponse),
    map(event => (event as HttpResponse<T>).body as T)
  );
